import { Download } from "lucide-react";
import Image from "next/image";

import { Button } from "~/components/ui/button";
import { Card, CardContent } from "~/components/ui/card";
import { type FragmentOf, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function PublicationTeaser(props: {
  record: FragmentOf<typeof fragment.publicationTeaserFragment>;
}) {
  const record = readFragment(fragment.publicationTeaserFragment, props.record);

  const { abstract, ctaUrl, pretitle, ctaLabel, subtitle, title, cover } = record;

  return (
    <div className="group container mx-auto mb-10">
      <Card className="group bg-background/50 relative grid h-full grid-cols-6 overflow-hidden backdrop-blur-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-lg">
        <div className="relative col-span-3 overflow-hidden">
          {cover && cover.url && (
            <Image
              src={`${cover.url}?w=350&h=400&auto=format&dpr=2`}
              alt={title}
              width={350}
              height={400}
              className="p-6 opacity-80 transition-all group-hover:opacity-100"
            />
          )}
        </div>
        <CardContent className="col-span-3 p-6 pl-0">
          <div className="space-y-2">
            {pretitle && <p className="text-muted-foreground text-sm">{pretitle}</p>}
            <h3 className="group-hover:text-primary text-2xl font-bold tracking-tight transition-colors">
              {title}
            </h3>
            {subtitle && <p className="text-muted-foreground">{subtitle}</p>}
            {abstract && <p className="text-muted-foreground">{abstract}</p>}
          </div>
          {ctaUrl && (
            <Button variant="secondary" className="relative z-10 mt-6 w-auto" asChild>
              <a
                href={ctaUrl}
                download
                className="after:absolute after:inset-0 after:-z-10 after:origin-center after:scale-[20] after:content-['']"
              >
                <Download className="mr-2 h-4 w-4" />
                {ctaLabel || "Download"}
              </a>
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
